<template>
  <div>
    <ul v-if="registration.payload && registration.payload.registeredClasses" class="pl-0">
      <li v-for="group in registration.payload.registeredClasses">
        Klassenstufe {{ group.ageGroup }}: {{ group.count }} Schüler ({{ group.type === 'online' ? 'online' : 'papierbasiert' }})
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'CompetitionRegistrationsDetails',
  props: ['registration']
}
</script>


// WEBPACK FOOTER //
// src/components/competitions/details/RegisteredClasses.vue